import {
  allergenDetectManifest,
  menuDetectMetadataManifest,
  menuTranslateManifest,
  textGenerateManifest,
} from '@foodlista/operations'

/**
 * Scope projections of the scoped operations, kept free of Nuxt imports so the
 * contract test can exercise the very functions `defineScopedOperation` uses.
 * Every key a projector declares must be emitted by the operation's context
 * projection, otherwise the operation can never rehydrate — see
 * `utils/scope-context-contract.test.ts`.
 */
export function allergenDetectScopePayload(scope: { productId?: string }) {
  return {
    productId: scope.productId,
  }
}

export function menuTranslateScopePayload(scope: { flowId: string }) {
  return {
    flowId: scope.flowId,
  }
}

export function menuDetectMetadataScopePayload(scope: { flowId: string }) {
  return {
    flowId: scope.flowId,
  }
}

export function textGenerateScopePayload(scope: { scopeKey: string }) {
  return {
    scopeKey: scope.scopeKey,
  }
}

/**
 * Loose shape for iteration seams: the contract test walks every scoped
 * operation, so it cannot know each projector's concrete scope type.
 */
export type ScopeProjector = (scope: never) => Record<string, unknown>

export const scopePayloadByType: Record<string, ScopeProjector> = {
  [allergenDetectManifest.type]: allergenDetectScopePayload,
  [menuTranslateManifest.type]: menuTranslateScopePayload,
  [menuDetectMetadataManifest.type]: menuDetectMetadataScopePayload,
  [textGenerateManifest.type]: textGenerateScopePayload,
}
